import React from 'react';
import TraderSelectField from 'components/TraderSelectField';
import GradeSelectFilter from 'components/GradeSelectFilter';
import CityFieldFilter from 'components/CityFieldFilter';
// import SelectStatusFilter from '../SelectStatusFilter';

const getTraderFullName = (trader) => {
  if (!trader || typeof trader === 'string') return trader || '';

  return (
    [trader.firstName, trader.middleName, trader.lastName]
      .filter(Boolean)
      .join(' ') ||
    trader.entityName ||
    trader.phone ||
    ''
  );
};

const OffersFilter = ({ statusFilter }) => {
  const gradeFilter = {
    key: 'status',
    value: 'ALL',
    type: 'STRING',
    op: 'EQ',
  };
  return (
    <>
      <TraderSelectField
        name="trader"
        label="Seller"
        statusFilter={statusFilter}
        getOptionLabel={getTraderFullName}
      />

      <GradeSelectFilter
        name="grade"
        label="Grade"
        statusFilter={gradeFilter}
      />

      <CityFieldFilter label="City" name="cityName" />
    </>
  );
};

export default OffersFilter;
